import Vue from 'vue';
import formatPhone from '@/utils/formatPhone';

Vue.filter('formatPhone', formatPhone);
Vue.filter('formatMoney', (money) => {
  try {
    return money.toLocaleString('ru-RU');
  } catch (error) {
    return money;
  }
});
Vue.filter('getPayoutType', (balance) => {
  if (balance > 0) {
    return 'accrual';
  }
  if (balance < 0) {
    return 'debit';
  }

  return 'neutral';
});
Vue.filter('toTwoFixed', (num) => (num === '' || num === 0 ? 0 : parseFloat(num).toFixed(2)));
